import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ChevronDown, ChevronLeft, ChevronRight, Check } from "lucide-react";
import "./index.css";
import Card from "./Card";

export default function ServiceAccordion(props) {
  const {
    service,
    onToggle,
    isExpanded,
    selectedExtraServices,
    onSelect,
    onDeselect,
    onCtaClick,
    ctaLabel,
  } = props;

  const [carouselIndex, setCarouselIndex] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);

  const handlePrev = useCallback(() => {
    setCarouselIndex((prev) => Math.max(prev - 1, 0));
  }, []);

  const handleNext = useCallback(() => {
    setCarouselIndex((prev) =>
      Math.min(prev + 1, service.extraservices.length - 1)
    );
  }, []);

  const selected = useMemo(
    () =>
      service.extraservices.find((el) =>
        selectedExtraServices.includes(el.value)
      ),
    [service.extraservices, selectedExtraServices]
  );

  // const showUpgradeLabel = useMemo(() => {
  //   if (selected === undefined) {
  //     return false;
  //   }

  //   return !!service.extraservices.find(
  //     (el) => (el.realvalue || 0) > (selected.realvalue || 0)
  //   );
  // }, [selected, service.extraservices]);

  useEffect(() => {
    if (!isExpanded) return;

    const el = document.getElementById(`carousel-${service.id}`);

    const handleWidth = () => {
      if (el) {
        setCardWidth(el.offsetWidth);
      }
    };

    handleWidth();

    window.addEventListener("resize", handleWidth);

    return () => {
      window.removeEventListener("resize", handleWidth);
    };
  }, [isExpanded]);

  return (
    <div
      className={`sa-container ${isExpanded ? "expanded" : ""} ${
        !!selected && !isExpanded ? "selected" : ""
      }`}
    >
      <div className="sa-collapsed" onClick={onToggle}>
        {selected && !isExpanded && <Check className="sa-check" />}
        <div className="sa-collapsed-header">
          <div className="sa-collapsed-title">
            <div>
              {service.optional && !selected && (
                <small>
                  Puoi decidere di aggiungerlo in un secondo momento, in Area
                  Riservata
                </small>
              )}
              <h3>{service.title}</h3>
            </div>
            <span
              className={`sa-badge ${
                service.optional ? "sa-badge-optional" : "sa-badge-required"
              }`}
            >
              {service.optional ? "Opzionale" : "Obbligatorio"}
            </span>
          </div>
          {selected && !isExpanded ? (
            <>
              <p>
                {selected.label} - €
                {selected.isVisualPrice
                  ? selected.visualPriceAmount
                  : selected.realvalue / 100}
              </p>
              {/* {showUpgradeLabel && ( */}
              <small>
                Puoi gestire e, quando disponibile, migliorare la
                personalizzazione da Area Riservata o da App Club
              </small>
              {/* )} */}
            </>
          ) : (
            <p
              className={`${service.optional ? "optional" : ""} ${
                isExpanded ? "expanded" : ""
              }`}
            >
              {service.subtitle}
            </p>
          )}
        </div>
        <ChevronDown className={isExpanded ? "expanded" : undefined} />
      </div>

      {isExpanded && (
        <div className="sa-body">
          {/* Desktop */}
          <div className="desktop-only sa-options-grid">
            {service.extraservices
              .filter((x) => x.visibilityForm)
              .map((opt) => {
                const isSelected =
                  selectedExtraServices &&
                  selectedExtraServices.includes(opt.value);
                const value = opt.isVisualPrice
                  ? opt.visualPriceAmount
                  : opt.realvalue;
                const isSuggested = !!opt.suggested;
                return (
                  <Card
                    isSuggested={isSuggested}
                    isSelected={isSelected}
                    key={opt.serviceId}
                    onClick={() => onSelect(opt.value)}
                    label={opt.label}
                    price={value / 100}
                    description={opt.description}
                  />
                );
              })}
          </div>

          {/* Mobile Carousel */}
          <div
            className="mobile-only sa-carousel"
            id={`carousel-${service.id}`}
          >
            <div
              className="sa-carousel-track"
              style={{
                transform: `translateX(calc(-${cardWidth * carouselIndex}px))`,
                width: `${cardWidth * service.extraservices.length}px`,
              }}
            >
              {service.extraservices
                .filter((x) => x.visibilityForm)
                .map((opt, i) => {
                  const isSelected =
                    selectedExtraServices &&
                    selectedExtraServices.includes(opt.value);
                  const value = opt.isVisualPrice
                    ? opt.visualPriceAmount
                    : opt.realvalue;
                  const isSuggested = !!opt.suggested;
                  return (
                    <Card
                      isSuggested={isSuggested}
                      isSelected={isSelected}
                      key={opt.serviceId}
                      onClick={() => onSelect(opt.value)}
                      label={opt.label}
                      price={value / 100}
                      isMobile
                      width={cardWidth}
                      description={opt.description}
                    />
                  );
                })}
            </div>

            <div className="sa-carousel-buttons">
              <button
                className="sa-carousel-btn left"
                onClick={handlePrev}
                disabled={carouselIndex === 0}
              >
                <ChevronLeft />
              </button>

              <button
                className="sa-carousel-btn right"
                onClick={handleNext}
                disabled={carouselIndex === service.extraservices.length - 1}
              >
                <ChevronRight />
              </button>
            </div>
          </div>
          {!!onCtaClick && !!ctaLabel && (
            <div className="sa-actions">
              <button className="sa-primary-btn" onClick={onCtaClick}>
                Scopri i pacchetti tutto incluso "{ctaLabel}"
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
